import * as z from "zod";

export const getAccountingOAuthUrl = {
  name: "getAccountingOAuthUrl" as const,
  input: z.null(),
  output: z.object({ url: z.string() }),
};
